<template>
  <el-card>
    <div style="margin-bottom: 20px;">
      <el-select clearable v-bind:value="this.$route.query.status" @input="statusChange" placeholder="请选择状态">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <page-table :data-api="this.api.activity" viewable>
      <el-table-column prop="id" label="编号" width="100">
      </el-table-column>
      <el-table-column prop="title" label="活动名称">
      </el-table-column>
      <el-table-column prop="startDate" label="活动日期" :formatter="function(row){return row.startDate+' 至 '+row.endDate }">
      </el-table-column>
      <el-table-column prop="viewer" label="浏览量" width="80">
      </el-table-column>
      <el-table-column label="状态" width="80">
        <template scope="scope">
          <span :style="{color:getStatusColor(scope.row.status)}">{{scope.row.status}}</span>
        </template>
      </el-table-column>
    </page-table>
  </el-card>
</template>
<script>
import Moment from 'moment'
export default {
  data () {
    return {
      options: [{
        value: '1',
        label: '未开始'
      }, {
        value: '2',
        label: '进行中'
      }, {
        value: '3',
        label: '已过期'
      }, {
        value: '4',
        label: '草稿'
      }]
    }
  },
  watch: {
    status: function (val) {

    }
  },
  methods: {
    getStatus (row) {
      let result = {}
      let now = Moment().format('YYYY-MM-DD')
      if (!row.publishDate) {
        result.text = '草稿'
        result.color = '#F7BA2A'
      } else if (row.startDate > now) {
        result.text = '未开始'
        result.color = '#20A0FF'
      } else if (row.startDate <= now && row.endDate >= now) {
        result.text = '进行中'
        result.color = '#13CE66'
      } else {
        result.text = '已结束'
        result.color = '#FF4949'
      }
      return result
    },
    getStatusColor (status) {
      if (status === '草稿') {
        return '#F7BA2A'
      } else if (status === '未开始') {
        return '#20A0FF'
      } else if (status === '进行中') {
        return '#13CE66'
      } else {
        return '#FF4949'
      }
    },
    statusChange (val) {
      let query = Object.assign({}, this.$route.query)
      if (val) { query.status = val } else { delete query.status }
      this.$router.replace({ query: query })
    }
  }
}
</script>



// WEBPACK FOOTER //
// List.vue?79ac0b3a